<template lang="pug">
  .items-center.justify-start(:class="{'flex': horizontal}") 
    //- div {{mainSelect}}
    //- div {{error}}
    v-select(
      :disabled= "isDisable"
      :clearable="clearable"
      :placeholder="placeholder" 
      v-model="mainSelect" 
      :options='data' 
      :selectable="option => !option.disabled"
      @close="close"
      @open="open"
      @search:blur="onBlur"
      @input="onClick()"
      ref="select"
      :calculate-position="isPositionTop"
      :append-to-body="position"
      :label="optionArr.id ? 'id': 'name'"
      :searchable="isSearch"
      :close-on-select="true"
      :class="{'validError': validClass}")
      //- :selectable="option => !option.selectable"  下拉選項 disabled
      //- :reduce="optionArr => optionArr.id? optionArr.id : optionArr" //bug tbd
      //- :calculate-position="withPopper" //自動化上下拉
      //- append-to-body


      //- template(#options="{option}"  )
      //-   //-  slot="option" slot-scope="option"  #option="{option}" 
      //-   .flex.justify-between(@mousedown="onmousedown(option.id ? option.id: option.label)" )
      //-     span {{option.name ? option.name : option.label}}
      template(#option="{name ,first ,id ,label }"   )
        .pt-0.groupType(v-if="first ")
          span.font-700(v-if="first && groupType")  {{groupType}} - 
          span.font-700(v-if="first") 
        .h-32.option.flex.justify-between.items-center(@mousedown="onmousedown(id ? id: label)" :disabled="true" )
          span {{name ? name : label}}
          iCon.h-24.w-24.inline-block.text-main-0(iconClass="check" type="svg" v-if="mainSelect.id == id && showCheckIcon")
        
      template( #no-options="{ search, searching }" v-if="isSearch") 
        em(v-if="searching ") Sorry, no {{search}}'s matching options.
        //- em(v-else) Sorry, no options.
      //-   //"onBlur()" 
    .error.flex.items-center(v-show="error")
      small.text-error.pt-3 {{error}}


</template>

<script>
import Vue from "vue";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { createPopper } from '@popperjs/core'

Vue.component("v-select", vSelect);
export default {
  name: 'Select',
  props: {
    position:{
      type: Boolean,
      required: false,
      default: false,
    },
    optionReverse:{
      type: Boolean,
      required: false,
      default: false,
    },
    clearable:{
      type: Boolean,
      required: false,
      default: false,
    },
    searchArr:{
      type: Array,
      require: false,
    },
    groupType:{
      type:String,
      required:false,
    },
    horizontal:{
      type: Boolean,
      required: false,
      default: false,
    },
    isSearch:{
      type: Boolean,
      required: false,
      default: false,
    },
    title: {
      type: String,
      required: false
    },
    optionArr:{
      type: Array,
      require: false,
    },
    defaultSelectedValue: {
      type: [String, Array,Number, Object],
      required: false,
      default: '',
    },
    placeholder:{
      type: String,
      required: false,
    },
    required:{ //blur時紅框
      type: Boolean,
      default: false,
    },
    error: String, //驗證文字
    name:String, //此欄位名稱
    isDisable: {
      type: Boolean,
      required: false,
      default: false,
    },
    showCheckIcon: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components:{
    vSelect,
  },
  data() {
    return {
      placement: 'top' ,
      data:[],
      mainSelect: this.defaultSelectedValue,
      validClass: false,
      obj:[
        {id: 'ax',
          name: 'aaaaa',
        },
        {id: 'bx',
          name: 'bbbbb',
        },
        {id: 'cx', 
          name: 'ccccc',
        },
        {id: 'dx', 
          name: 'ddddd',
        },

      ],
      temp:'',
      isEmptyResult:false, //optionarr內沒有東西
      noSearchResult: false //
    };
  },
  created(){
  },
  mounted(){
    // this.data = this.optionArr;
    this.validClass = this.error ? true : false;
  },
  methods:{

    open(){
      this.$emit("emptyResult", false);
    },
    onmousedown(id) {
      this.temp = id;
    },
    onClick() {
      // console.log(this.mainSelect)
      this.$emit("onClick", this.mainSelect);
      if(!this.mainSelect) {
        this.$emit("emptyResult", false);
      }
    },
    close(){
      // this.$emit("emptyResult", false);
    },
    
    onBlur(){
      if(!this.mainSelect && this.required ){
        this.validClass = true
      }else{
        this.validClass = false
      }
      this.$emit("onblur",{ val: !this.validClass, key: this.name});

      this.$emit("emptyResult", this.noSearchResult);
    },
    withPopper(dropdownList, component, { width }) {

      dropdownList.style.width = width

      const popper = createPopper(component.$refs.toggle, dropdownList, {
        placement: this.placement,
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: [0, -1],
            },
          },
          {
            name: 'toggleClass',
            enabled: true,
            phase: 'write',
            fn({ state }) {
              component.$el.classList.toggle(
                'drop-up',
                state.placement === 'top'
              )
            },
          },
        ],
      })

      return () => popper.destroy()
    },
  },
  computed: {
    isPositionTop(){ //按下repack 
      return this.position ? this.withPopper : ()=>{}
    },

  },
  watch:{
    '$store.state.user.langIsSelected': function() {
      if(this.defaultSelectedValue['i18n']){
        this.mainSelect = this.$t(this.defaultSelectedValue['i18n']) 
      }
    },
    defaultSelectedValue:{
      handler: function (n) { //驗證有填選則開啟BTN
        this.mainSelect =  n
      },
      deep:true,
    },
    optionArr:{
      handler: function (newval) { //驗證有填選則開啟BTN
        this.data = newval;
      },
      deep:true,
      immediate : true,
    },
    isEmptyResult:{
      handler: function (n) { //驗證有填選則開啟BTN
        this.noSearchResult = n
      },
      deep:true,
    },
    error:{
      handler: function (n) { //驗證有填選則開啟BTN
        this.validClass = n ? true : false;
      },
      deep:true,
    },
    

  },
}
</script>

<style lang="scss" scoped>

// .v-select.drop-up.vs--open .vs__dropdown-toggle {
//   border-radius: 0 0 4px 4px;
//   border-top-color: transparent;
//   border-bottom-color: rgba(60, 60, 60, 0.26);
// }

// [data-popper-placement='top'] {
//   border-radius: 4px 4px 0 0;
//   border-top-style: solid;
//   border-bottom-style: none;
//   box-shadow: 0 -3px 6px rgba(0, 0, 0, 0.15);
// }
</style>
